export const authPrefix = '/auth';
export const signIn = '/signin';
export const signUp = '/signup';
export const recoverPassword = '/recover_password';

export const productsPrefix = '/products';
export const productsDetails = '/:productId';

export const sitesPrefix = '/sites';

export const usersPrefix = '/users';

export const profilePrefix = '/profile';

export const datasheetsPrefix = '/datasheets';

export const customersPrefix = '/customers';
export const customerId = '/:customerId([a-z0-9-]{36})';
export const orderListId = '/:orderListId([a-z0-9-]{36})';

export const documentsPrefix = '/documents';
export const documentId = '/:documentId([a-z0-9-]{36})';

export const aclPrefix = '/acl';
export const aclPoliciesPrefix = `/policies`;
export const policyId = '/:policyId([a-z0-9-]{36})';
export const aclUsersGroupsPrefix = `/groups`;
export const userGroupId = '/:userGroupId([a-z0-9-]{36})';

export enum DocLinkType {
  DATA_SHEET = 'data_sheet',
  DATA_SHEET_TEMPLATE = 'data_sheet_template',
  NOT_SET = 'not_set',
  ORDER_LIST = 'order_list',
  PRODUCT = 'product',
  SERIAL_NUMBER = 'serial_number'
}
export const documentLinkType = `/:linkType(${DocLinkType.PRODUCT}|${DocLinkType.SERIAL_NUMBER}|${DocLinkType.ORDER_LIST})`;

export const qrPrefix = '/qr';
